export enum LambdaInvocationType {
  EVENT = 'Event',
  REQUEST_RESPONSE = 'RequestResponse',
  DRY_RUN = 'DryRun',
}
